import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import jwt_decode from 'jwt-decode';

import { Col, Row } from 'reactstrap';
import { } from "react-icons/bs";

import PageHeader from '../components/PageHeader';
import { StyledButton } from '../components/UI/index';
import { ProjectItemModal, ProjectListHeader, ProjectListItem } from '../components/project';
import { fetchProjects, deleteProject, addProject, editProject } from '../redux/projectSlice';
import { fetchDictionaties } from '../redux/catalogSlice';
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';

const ProjectsPage = () => {
    const dispatch = useDispatch();
    const { list, isLoading, error } = useSelector(state => state.projects);
    const { user } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const [projectForEdit, setProjectForEdit] = useState(null);
    const [isAdmin, setIsAdmin] = useState(1);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemForDelete, setItemForDelete] = useState(null); //{entityId: 12}

    useEffect(() => {
        //console.log(user);
        if (user) {
            const { accessToken } = user;
            const decoded = jwt_decode(accessToken);
            const role = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === 'Администратор' ? 0 : 1;
            setIsAdmin(parseInt(role));
        }
    }, [user]);

    //useEffect(() => {
    //    console.log('isAdmin', isAdmin)
    //}, [isAdmin])

    useEffect(() => {
        dispatch(fetchProjects());
        const interval = setInterval(() => {
            dispatch(fetchDictionaties());
            dispatch(fetchProjects());
        }, 10000);
        return () => clearInterval(interval);
    }, [dispatch]);

    const onAddProjectHandler = () => {
        setProjectForEdit(null);
        setShowModal(true);
    };

    const onEditProjectHandler = (id) => {
        const selectedProject = list.find(station => station.id === id);
        setProjectForEdit({ ...selectedProject });
        setShowModal(true);
    };

    const onShowDeleteModalHandler = (id) => {
        setItemForDelete({ entityName: list.find(p => p.id === id).name, entityId: id })
        setShowDeleteModal(true);
    }

    const onDeleteHandler = (request) => {
        if (request?.answer === true)
            dispatch(deleteProject(request?.entityId));
    };

    const onSaveChangesHandler = (projectItem) => {
        if (projectItem.id === null) {
            dispatch(addProject(projectItem));
        } else {
            dispatch(editProject(projectItem));
        };
    };

    return (
        <>
            <PageHeader
                name="Проекты"
                //isLoading={isLoading}
                isVisible={isAdmin === 0 ? true : false}
                onClickHandler={onAddProjectHandler}
            />

            {error && <h2>Ошибка: {error}</h2>}

            <div className='project-list-container'>
                <ProjectListHeader />

                {list.length > 0 ?
                    list.map(project => {
                        const { id } = project;

                        return (
                            <ProjectListItem
                                key={id}
                                project={project}
                                onArchiveProjectHandler={onShowDeleteModalHandler}
                                onEditProjectHandler={onEditProjectHandler}
                                showActions={isAdmin === 0 ? true : false}
                            />
                        );
                    })
                    :
                    <div className='no-items'>Список пока пуст.</div>
                }

                <ProjectItemModal
                    setShowModal={setShowModal}
                    showModal={showModal}
                    project={projectForEdit}
                    onSaveChangesHandler={onSaveChangesHandler}
                />
            </div>
            <ConfirmDeleteModal
                entityName={'проект "' + itemForDelete?.entityName + '"'}
                entityId={itemForDelete?.entityId}
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                onDeleteHandler={onDeleteHandler}
            />
        </>
    );
};

export default ProjectsPage;

